import { ChakraProvider } from '@chakra-ui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import App from './App'
import theme from '@ocean/shared/utils/theme/theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response?.status
        if (typeof status === 'number' && status >= 400) return false
        return failureCount < 1
      },
    },
  },
})

if (import.meta.env.VITE_IS_LOCAL !== 'true') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    denyUrls: [/framer-motion/i, /style-value-types/i],
    enableLogs: true,
  })
}

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </QueryClientProvider>
)

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        if (import.meta.env.DEV) console.log('Service worker registered:', reg)
      })
      .catch((err) => {
        console.error('Service worker registration failed:', err)
      })
  })
}
